import { useDispatch } from 'react-redux';
import { RouteName, TextKey } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { LocalizedText } from '@mews/framework';
import { Button, IconName } from '@optimus-web/core';
import { openInBrowserTab } from '@mews-commander/utils';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { setDataToFetch, setFetchFlag } from '../../../actions';
import { DataType } from '../../../types';

export const UploadButton = () => {
    const resolveRoute = useResolveRoute();
    const currentEnterpriseId = useCurrentEnterpriseId();
    const dispatch = useDispatch();

    const createHeadingActionClickHandler = () => {
        const uploadUrl = resolveRoute(RouteName.EnterpriseRateManagementRateUpload, {
            query: {
                PortfolioId: currentEnterpriseId,
            },
        });
        dispatch(setFetchFlag(true));
        dispatch(setDataToFetch(DataType.RateType, null));
        openInBrowserTab(uploadUrl);
    };
    return (
        <Button
            size="medium"
            icon={IconName.Imports}
            variant="tertiary"
            onClick={() => createHeadingActionClickHandler()}
            type="submit"
        >
            <LocalizedText textKey={TextKey.ImportRates} />
        </Button>
    );
};
